import {
  AggregateRatingOriginContent,
  FAQItem,
  getFAQRichSearch,
  RICH_SEARCH_TYPES,
} from "@/utils/richSearch";

const RecommendationParlorFAQData: FAQItem[] = [
  {
    question: "장례 비용은 얼마정도 발생하나요?",
    answer:
      "장례 비용은 장례를 진행하실 장례식장의 빈소 대여료, 조문객 수 등에 따라 금액적인 차이가 큽니다. 장례식장의 위치, 빈소 비용, 세부 품목별 비용을 확인하세요. 아직 고민중이라면 고이의 추천을 받아보세요. 24시간 상담 (1666-9784) <a href='https://goifuneral.co.kr/match/request'>비용 견적 받아보기</a>",
  },
  {
    question: "장례식장은 미리 예약할 수 있나요?",
    answer:
      "아니요, 장례식장은 가족분이 임종 하셨을 때, 이용 가능 여부를 확인해야합니다. 특히 지나치게 큰 평수의 빈소를 이용하지 않도록 주의하셔야하고, 상담을 통해 염두에 두고 있는 장례식장의 비용이나, 주변 장례식장 비용 비교까지 도와드립니다. 24시간 상담 (1666-9784)",
  },
];

const defaultAggregateRatingData: AggregateRatingOriginContent = {
  "@type": RICH_SEARCH_TYPES.AGGREGATE_RATING,
  ratingValue: "4.9",
  bestRating: "5",
  ratingCount: "23",
};

const FAQRichSearch = getFAQRichSearch(RecommendationParlorFAQData);

export const RecommendationParlorRichSearch = {
  FAQRichSearch,
  defaultAggregateRatingData,
};
